import { render, staticRenderFns } from "./flag.vue?vue&type=template&id=739819b9"
import script from "./flag.vue?vue&type=script&lang=js"
export * from "./flag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports